module.exports = __webpack_public_path__ + "img/pytrace-settings-menu.faf6e39c.png";